<template>
  <page-edicion>
    <formulario-campania :campania="campania" :descuentos="descuentos" @submit="insertar" />
  </page-edicion>
</template>

<script>
import FormularioCampania from "./FormularioCampania.vue";
import campaniaApi from "@/services/campanias.js";

export default {
  components: { FormularioCampania },
  data() {
    return {
      campania: campaniaApi.crear(),
      descuentos: [],
    };
  },
  mounted() {
    this.cargarPlazosDescuento();
  },
  methods: {
    insertar() {
      campaniaApi.insertar(this.campania, this.descuentos).then(() => {
        this.$messages.success("Campaña creada correctamente");
        this.$router.push({ path: "/campanias" });
      });
    },
    async cargarPlazosDescuento() {
      this.descuentos = await campaniaApi.cargarPlazosDescuento();
    },
  },
};
</script>
